'use client';

import * as React from 'react';
import { styled } from '@linaria/react';
import { Hand as IconHand } from 'lucide-react';

import VisuallyHidden from '@/components/VisuallyHidden';

import ToolButton from './ToolButton';
import { ConnectedIconBomb as IconBomb } from './IconBomb';
import IconEraser from './IconEraser';
import IconWand from './IconWand';

export interface Props {}

function IconBoopDemo({}: Props) {
  return (
    <Wrapper>
      <ToolButton index={0} transformOrigin="50% 80%">
        <IconHand aria-hidden="true" size={64} />
        <VisuallyHidden>Select “Grabber” tool</VisuallyHidden>
      </ToolButton>

      <ToolButton customBoop index={1} transformOrigin="50% 91.6%">
        <IconEraser size={64} aria-hidden="true" />
        <VisuallyHidden>Select “Eraser” tool</VisuallyHidden>
      </ToolButton>
      <ToolButton index={2} transformOrigin="37.5% 62.5%">
        <IconBomb size={64} />
        <VisuallyHidden>Select “Bomb” tool</VisuallyHidden>
      </ToolButton>

      <ToolButton customBoop index={3} transformOrigin="37.5% 62.5%">
        <IconWand size={64} />
        <VisuallyHidden>Select “Wand” tool</VisuallyHidden>
      </ToolButton>
    </Wrapper>
  );
}

const GAP = 8;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  gap: ${GAP}px;
  margin-inline: auto;
  margin-top: 2rem;
  margin-bottom: 4rem;
  padding: ${GAP}px;
  border-radius: 16px;
  pointer-events: auto;

  html[data-color-mode='dark'] & {
    outline: 1px solid var(--color-gray-200);
  }
  html[data-color-mode='light'] & {
    box-shadow:
      0px 1px 2px hsl(0deg 0% 0% / 0.1),
      0px 2px 4px hsl(0deg 0% 0% / 0.1),
      0px 8px 16px hsl(0deg 0% 0% / 0.1),
      0px 24px 48px hsl(0deg 0% 0% / 0.1);
  }
`;

export default React.memo(IconBoopDemo);
